/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChevronUp = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.9547 10.315L17.4393 15.7998L18.5 14.7391L13.0153 9.25431L11.9547 8.29978L10.894 9.25431L5.40921 14.7393L6.46987 15.7999L11.9547 10.315Z"
                        fill={color}
                    />
                </svg>
        );
    };
